// extracted by mini-css-extract-plugin
export var table = "_xm-0";